import ProfileApis from '@/services/apis/profile'

const profile = new ProfileApis()
export default {
  props: {
    card: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      sendMaliLoading: false,
      remainingTime: {
        minutes: 0,
        seconds: 0,
      },
      remainingSeconds: 0, // Initial number of seconds (5 minutes)
    }
  },
  mounted() {
    profile.get().then(res => {
      if (!res.data.results.user.isActive) {
        this.resendActivationEmail()
      }
    }).finally(() => {
      this.show = false
    })
  },

  methods: {
    resendActivationEmail() {
      this.sendMaliLoading = true
      profile.reSendActivationMail({ email: this.$store.state.auth.user.email }).then(res => {
        this.remainingSeconds = res.data.results.remained_expiration_time
        if (this.remainingSeconds) {
          this.updateCountdown()
        }
        this.$swal({
          title: `${this.$t('activationEmailSent')}`,
          icon: 'success',
          timer: 2500,
          showConfirmButton: true,
        })
      }).catch(err => {
        if (err.data.status === 406) {
          this.remainingSeconds = err.data.results.remained_expiration_time
          if (this.remainingSeconds) {
            this.updateCountdown()
          }
        }
      })
        .finally(() => {
          this.sendMaliLoading = false
        })
    },
    formatTime(value) {
      return value.toString().padStart(2, '0')
    },
    updateCountdown() {
      if (this.remainingSeconds > 0) {
        this.remainingTime.minutes = Math.floor(this.remainingSeconds / 60)
        this.remainingTime.seconds = this.remainingSeconds % 60
        this.remainingSeconds -= 1

        setTimeout(this.updateCountdown, 1000) // Call itself after 1 second
      } else {
        this.remainingTime.minutes = 0
        this.remainingTime.seconds = 0
      }
    },
  },

}
